"use client"

import { Box, TextField, Button, Typography } from '@mui/material';
import QuestionnaireModal from 'components/Contact/questionnaire';
import { useWaitListForm } from 'components/Contact/useWaitListForm';
import { useState } from 'react';

const RegisterationForm = ({ questions, hasDeals }) => {
    const {
        email,
        setEmail,
        handleForm
    } = useWaitListForm({campaignName: 'Amazon_Deals_General'});
    const [questionaireModal, setQuestionaireModal] = useState(false);


    const handleSubmit = () => {
        handleForm();
        setQuestionaireModal(true);
    }

    return (
        <Box
            sx={{
                p: 4,
                mt: 6,
                borderRadius: 2,
                mx: 'auto',
                textAlign: 'center',
            }}
        >
            <Typography variant="h6" className="signup-text" gutterBottom>
                Want More Great Deals{hasDeals ? ' Like These?' : '?'}
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: 'black' }}>
                Drop your email below and we will let you know as soon as these are available
            </Typography>

            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
                <TextField
                    label="Email Address"
                    variant="outlined"
                    size="small"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    sx={{
                        minWidth: 270,
                        '& .MuiOutlinedInput-root': {
                            '&.Mui-focused fieldset': {
                                borderColor: 'var(--theme-dark)',
                            },
                        },
                        '& label.Mui-focused': {
                            color: 'var(--theme-dark)',
                        },
                    }}
                />

                <Button variant="contained" onClick={handleSubmit} className="signup-btn">
                    Register
                </Button>
            </Box>

            {questionaireModal && <QuestionnaireModal
                questionaireModal={questionaireModal}
                setQuestionaireModal={setQuestionaireModal}
                questions={questions}
                email={email}
            />}
        </Box>
    );
};

export default RegisterationForm;
